import { createReducer, on } from '@ngrx/store';
import { initialProjectHumanResourceState, ProjectHumanResourceState } from './project-human-resource.state';
import {
  loadProjectHumanResourcesByProject,
  loadProjectHumanResourcesByProjectSuccess,
  loadProjectHumanResourcesByProjectFailure,
  createProjectHumanResources,
  createProjectHumanResourcesSuccess,
  createProjectHumanResourcesFailure,
  updateProjectHumanResource,
  updateProjectHumanResourceSuccess,
  updateProjectHumanResourceFailure,
  updateProjectHumanResourcesRange,
  updateProjectHumanResourcesRangeSuccess,
  updateProjectHumanResourcesRangeFailure,
  deleteProjectHumanResource,
  deleteProjectHumanResourceSuccess,
  deleteProjectHumanResourceFailure,
} from './project-human-resource.actions';

export const projectHumanResourceReducer = createReducer(
  initialProjectHumanResourceState,

  // Load
  on(loadProjectHumanResourcesByProject, (state): ProjectHumanResourceState => ({
    ...state, loading: true, error: null,
  })),
  on(loadProjectHumanResourcesByProjectSuccess, (state, { items, projectId }): ProjectHumanResourceState => ({
    ...state, items, loadedProjectId: projectId, loading: false,
  })),
  on(loadProjectHumanResourcesByProjectFailure, (state, { error }): ProjectHumanResourceState => ({
    ...state, error, loading: false,
  })),

  // Create
  on(createProjectHumanResources, (state): ProjectHumanResourceState => ({
    ...state, saving: true, error: null,
  })),
  on(createProjectHumanResourcesSuccess, (state, { items }): ProjectHumanResourceState => ({
    ...state, items: [...state.items, ...items], saving: false,
  })),
  on(createProjectHumanResourcesFailure, (state, { error }): ProjectHumanResourceState => ({
    ...state, error, saving: false,
  })),

  // Update
  on(updateProjectHumanResource, (state): ProjectHumanResourceState => ({
    ...state, saving: true, error: null,
  })),
  on(updateProjectHumanResourceSuccess, (state, { item }): ProjectHumanResourceState => ({
    ...state,
    saving: false,
    items: state.items.map(i =>
      i.projectHumanResourceId === item.projectHumanResourceId ? item : i
    ),
  })),
  on(updateProjectHumanResourceFailure, (state, { error }): ProjectHumanResourceState => ({
    ...state, error, saving: false,
  })),

  // Update Range
  on(updateProjectHumanResourcesRange, (state): ProjectHumanResourceState => ({
    ...state, saving: true, error: null,
  })),
  on(updateProjectHumanResourcesRangeSuccess, (state, { items }): ProjectHumanResourceState => {
    const updatedById = new Map(items.map(item => [item.projectHumanResourceId, item]));
    return {
      ...state,
      saving: false,
      items: state.items.map(i => updatedById.get(i.projectHumanResourceId) ?? i),
    };
  }),
  on(updateProjectHumanResourcesRangeFailure, (state, { error }): ProjectHumanResourceState => ({
    ...state, error, saving: false,
  })),

  // Delete
  on(deleteProjectHumanResource, (state): ProjectHumanResourceState => ({
    ...state, saving: true, error: null,
  })),
  on(deleteProjectHumanResourceSuccess, (state, { id }): ProjectHumanResourceState => ({
    ...state,
    saving: false,
    items: state.items.filter(i => i.projectHumanResourceId !== id),
  })),
  on(deleteProjectHumanResourceFailure, (state, { error }): ProjectHumanResourceState => ({
    ...state, error, saving: false,
  })),
);
